import React from 'react';
import PropTypes from 'prop-types';

import { PreviewCondition } from '@sopranodesign/pulse-components';

import ConditionPreview from '../../ConditionPreview';

const LanguagePreview = ({ prefix = 'When', ...props }) => (
  <p>
    {prefix}
    {props.flipped === 1 && ' not'} {`user's language`}
    <PreviewCondition>{props.type.name}</PreviewCondition>
    <ConditionPreview {...props} />
  </p>
);

LanguagePreview.propTypes = {
  prefix: PropTypes.string,
  flipped: PropTypes.number,
  type: PropTypes.shape({ type: PropTypes.string, name: PropTypes.string })
};

export default LanguagePreview;
